var waitFor = require('../utils/waitFor');
var stickyTableHeaders = require('../lib/stickyTableHeaders');

waitFor('table.sticky-header', function() {

  $('table.sticky-header').stickyTableHeaders();

});
